/**
 * @generated SignedSource<<37b313f79c6a03c4fa93aaac275bdf29>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type url_issueFieldUrlInlineEditFull_UrlInlineEditView_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef">;
  readonly " $fragmentType": "url_issueFieldUrlInlineEditFull_UrlInlineEditView_fragmentRef";
};
export type url_issueFieldUrlInlineEditFull_UrlInlineEditView_fragmentRef$key = {
  readonly " $data"?: url_issueFieldUrlInlineEditFull_UrlInlineEditView_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"url_issueFieldUrlInlineEditFull_UrlInlineEditView_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditView_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraUrlField"
};

(node as any).hash = "5aed5e7bdc192a64e4e820aace0e3608";

export default node;
